/**
 * HOME-CALENDAR-SKELETON.WIDGET
 * Skeleton adapté à home-calendar.widget.tsx : titre centré puis une liste d'évènements
 * (barre de couleur à gauche, nom, projet), de la même hauteur que la liste réelle.
 */
import Skeleton from "@/components/skeleton"

export default function HomeCalendarSkeletonWidget() {
  return (
    <div>
      <div className="flex" style={{ padding: 24, justifyContent: "center" }}>
        <Skeleton width={170} height={20} />
      </div>

      <div style={{ height: 378 }}>
        {[150, 110, 190, 130].map((width, i) => (
          <div key={i} className="flex rel" style={{ padding: "20px 24px", alignItems: "center", gap: 24 }}>
            <Skeleton width={10} height={"100%"} borderRadius={0} className="abs" style={{ top: 0, left: 0 }} />
            <div style={{ marginLeft: 10 }}>
              <Skeleton width={width} height={14} />
            </div>
            <div style={{ flex: 1 }} />
            <Skeleton width={110} height={12} />
          </div>
        ))}
      </div>
    </div>
  )
}
